import styled from 'styled-components';

export const StyledError = styled.section`
  min-height: calc(100vh - 6vh - 8vh);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-4);
  text-align: center;
  padding: var(--space-8) var(--space-4);

  h1 {
    font-size: var(--fs-5xl);
    font-weight: var(--fw-black);
    color: var(--c-danger);
    line-height: var(--lh-tight);
  }

  h2 {
    font-size: var(--fs-2xl);
    font-weight: var(--fw-bold);
  }

  p {
    max-width: 46ch;
    color: var(--c-text-muted);
  }

  a {
    margin-top: var(--space-2);
    padding: var(--space-3) var(--space-6);
    background-color: var(--c-accent);
    color: #fff;
    font-weight: var(--fw-bold);
    border-radius: var(--radius-full);
    transition: background-color 0.2s ease;
  }

  a:hover {
    background-color: var(--c-accent-hover);
  }
`;
